import React from 'react';
import { Layout } from '@abyss/web/ui/Layout';
import { Router } from '@abyss/web/ui/Router';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { Grid } from '@abyss/web/ui/Grid';

import styles from './appbody.module.css';

export const AppBody = () => {
  return (
    <React.Fragment>
      <Header />
      <div className={styles.wrap}>
        <Router.Outlet />
      </div>
      <Footer />
    </React.Fragment>
  );
};
